import { Component, OnInit } from '@angular/core';
import { ScreenSaverService } from '../../../services/screen-saver.service';
import { ScreenSaverConfiguration } from '../../../lib/screen-saver-configuration';
import { VuCommunicationService } from '../../../services/vu/vu-communication.service';
import { ConfigurationService } from '../../../services/configuration/configuration.service';
import { DtoVuConfiguration } from '../../../lib/configuration';
import { LanguageService } from '../../../services/language.service';

@Component({
  selector: 'app-screen-saver-simulator',
  templateUrl: './screen-saver-simulator.component.html',
  styleUrls: ['./screen-saver-simulator.component.css']
})
export class ScreenSaverSimulatorComponent implements OnInit {

  constructor(
    private screenSaverService: ScreenSaverService,
    private vuCommunicationService: VuCommunicationService,
    private configurationService: ConfigurationService,
  ) {
  }

  ngOnInit() {
  }

  public get configuration(): ScreenSaverConfiguration {
    return this.screenSaverService.configuration;
  }

  get timeouts(): number[] {
    return Array.apply(null, { length: 101 }).map(Number.call, Number);
  }

  onTimeoutChange(event: any) {
    this._updateScreenSaverConfiguration();
  }

  onModeChange(event: any) {
    this._updateScreenSaverConfiguration();
  }

  onImageShowTimeoutChange(event: any) {
    this._updateScreenSaverConfiguration();
  }

  onTimeFromChange(event: any) {
    this._updateScreenSaverConfiguration();
  }

  onTimeToChange(event: any) {
    this._updateScreenSaverConfiguration();
  }

  _updateScreenSaverConfiguration() {
    var configuration = this.screenSaverService.configuration;
    this.vuCommunicationService.vuHttpSimulator.setScreenSaverConfiguration(configuration);
    this.vuCommunicationService.vuConnectionSimulator.configurationChanged(this.configurationService.configuration);
    this.vuCommunicationService.vuHttp.getVuConfiguration().then(
      result => {
        this.vuCommunicationService.vuConnectionSimulator.vuConfigurationChanged(result);
      }
    )
  }
}
